import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createNote, getNotes } from '../redux/actions/setNoteActions'
import { useLocation } from 'react-router-dom'
import { BackButton } from '../components/BackButton'
import { Loader } from '../components/Loader'
import Moment from 'react-moment'
import { Layout } from '../components/Layout'
import {SureAlert} from "../components/SureAlert";


const CreateNote = ({ createHandler, closeHandler }) => {
    const [form, setForm] = useState({ title: '', text: '' })
    const [isSureAlert, setIsSureAlert] = useState(false)
    function onSendClick(event) {
        setIsSureAlert(true);
    }
    function onCloseClick(event) {
        setIsSureAlert(false);
    }

    const changeHandler = event => {
        setForm({ ...form, [event.target.name]: event.target.value })
    }

    return (
        <Layout>
            <div className="page">
                <header className="page__header">
                    <button
                        onClick={closeHandler}
                        className="icon-btn page__icon-btn page__icon-btn_left icon-btn_back" />
                    <p className="page__title">Заметки</p>
                </header>

                <div className="school-page__wrapper">
                    <h3>Написать заметку</h3>
                    <div className="input-field input-field_yellow">
                        <input
                            id="title"
                            type="text"
                            name="title"
                            value={form.title}
                            placeholder="Заголовок заметки"
                            onChange={changeHandler}
                        />
                        <label htmlFor="number">Заголовок</label>
                    </div>
                    <div className="input-field input-field_yellow">
                        <input
                            id="text"
                            type="text"
                            name="text"
                            value={form.text}
                            onChange={changeHandler}
                            placeholder="Подробности заметки"
                        />
                        <label htmlFor="letter">Подробности</label>
                    </div>
                </div>

                <button
                    onClick={onSendClick}
                    disabled={!form.title || !form.text}
                    className="main-btn main-btn_yellow">Отправить</button>
            </div>
            {isSureAlert ? <SureAlert type='createNote' handleClose={onCloseClick} handleSubmit={() => {createHandler(form); onCloseClick()}}/> : ''}
        </Layout>
    )
}



export const NotesPage = () => {
    const dispatch = useDispatch()
    const { search } = useLocation()
    const [pupilId, setPupilId] = useState(null)
    const [note, setNote] = useState(null)
    const [isCreate, setIsCreate] = useState(false)
    const { notes } = useSelector(state => state.note)
    const { loading } = useSelector(state => state.app)
    const { role } = useSelector(state => state.auth)


    useEffect(() => {
        const query = new URLSearchParams(search)
        const pupilId = query.get('pupilId')
        dispatch(getNotes(pupilId))
        setPupilId(pupilId)
    }, [dispatch, search])

    const createHandler = async (form) => {
        dispatch(createNote({ ...form, pupilId }))
    }

    if (loading) return <Loader />

    if (isCreate) {
        return <CreateNote
            closeHandler={() => setIsCreate(!isCreate)}
            createHandler={createHandler} />
    }

    if (note) return (
        <Layout>
            <div className="page">
                <header className="page__header">
                    <button
                        onClick={() => setNote(null)}
                        className="icon-btn page__icon-btn page__icon-btn_left icon-btn_back" />
                    <p className="page__title">
                        <Moment locale="ru" format="DD MMM, YYYY">
                            {note.createdAt}
                        </Moment>
                    </p>
                </header>
                <div className="page__content">
                    <h3>{note.title}</h3>
                    <p>{note.text}</p>
                </div>
            </div>
        </Layout>
    )

    return (
        <Layout>
            <div className="page">
                <header className="page__header">
                    <BackButton />
                    {role === 'psych' && <button
                        onClick={() => setIsCreate(!isCreate)}
                        className=" icon-btn  page__icon-btn  page__icon-btn_right  icon-btn_add" />}
                    <p className="page__title">Заметки</p>
                </header>
                <div className="school-page__wrapper">
                    <div className="list">
                        {notes.map(note => {
                            const max = 70
                            return (
                                <div key={note._id} className="list__item-wrap">
                                    <p className="list__item-date">
                                        <Moment locale="ru" format="DD MMM, YYYY">
                                            {note.createdAt}
                                        </Moment>
                                    </p>
                                    <div
                                        className="list__item"
                                        onClick={() => setNote(note)}>
                                        <p>{note.title}</p>
                                        <p className="list__desc">
                                            {note.text.length > max
                                                ? note.text.slice(0, max).concat('...')
                                                : note.text}
                                        </p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                {role === 'psych' && <button
                    onClick={() => setIsCreate(!isCreate)}
                    className="main-btn main-btn_yellow">Написать заметку</button>}
            </div>
        </Layout>
    )
}